import React from 'react';
import { useDispatch } from 'react-redux';

import { Modal } from '@carbon/react';

import { hideForm } from 'services/forms';
import { showToast } from 'services/toasts';
import { useDeleteLocationMutation } from 'services/location';

const DeleteLocationModal = ({ location, hideModal }) => {
  const dispatch = useDispatch();
  const [deleteLocation] = useDeleteLocationMutation();

  let deletable = true;

  let ueberschrift = <p>
    {`Soll der Standort `}
    <span style={{fontWeight: 'bold'}}>
      {location.name}
    </span>
    {` wirklich gelöscht werden?`}
  </p>;

  if (location.devices.length > 0) {
    deletable = false;
    ueberschrift = <>
      {`Der Standort `}
      <span style={{fontWeight: 'bold'}}>
        {location.name}
      </span>
      {` kann nicht gelöscht werden!`}
      <br/><br/>
      <span style={{fontWeight: 'bold'}}>
        {`Es sind noch ${location.devices.length} Geräte mit diesem Standort verknüpft.`}
      </span>
      <br/><br/>
      {"Diese müssen zunächst gelöscht oder verschoben werden."}
    </>;
  }

  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText={deletable ? "Löschen" : "OK"}
      secondaryButtonText="Abbrechen"
      modalHeading={ueberschrift}
      onRequestClose={hideModal}
      onRequestSubmit={async () => {
        if (!deletable) {
          hideModal();
          return;
        }

        try {
          await deleteLocation(location.model.ID);
        } catch {
          dispatch(
            showToast({
              kind: 'error',
              title: 'Fehler',
              caption: 'Der Standort konnte nicht gelöscht werden',
            })
          );
        } finally {
          dispatch(hideForm());
          hideModal();
          dispatch(showToast({
            kind: 'success',
            title: 'Standort gelöscht',
            caption: 'Der Standort wurde erfolgreich gelöscht',
          }));
        }
      }}></Modal>
  );
};

export default DeleteLocationModal;
